import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconTextStyle: React.FC<IconProps> = ({ width = 23, height = 23, color = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 25 24"
            fill="none"
        >
            <g clip-path="url(#clip0_10693_2659)">
                <path
                    d="M12.963 18.9028C12.658 19.0806 12.2846 19.0951 11.9668 18.9416L12.2687 23.2002C12.3027 23.6506 12.6774 23.999 13.129 24.0002H14.8584C15.3335 24.0015 15.7198 23.6173 15.721 23.1421C15.721 23.1205 15.7203 23.0989 15.7187 23.0773L15.3263 17.5508L12.963 18.9028Z"
                    fill={color}
                />
                <path
                    d="M13.8798 9.11945C13.8332 9.02253 13.7957 8.92145 13.7677 8.81757C13.6589 8.38949 13.7224 7.93581 13.9445 7.55399C14.0989 7.30564 14.3141 7.10079 14.5698 6.95886L14.4361 5.06349C14.2506 2.58457 12.189 0.665696 9.7031 0.658203H7.18025C4.69486 0.665858 2.63394 2.58495 2.44937 5.06349L1.16638 23.0771C1.13182 23.551 1.48804 23.9631 1.96194 23.9977C1.9835 23.9992 2.00512 24 2.02673 23.9999H3.75607C4.20771 23.9988 4.58241 23.6503 4.61643 23.2L5.10159 16.3753C5.15226 15.6991 5.71505 15.1757 6.3932 15.1743H10.4923C10.8052 15.1744 11.1072 15.2886 11.3419 15.4956L11.3376 13.9344C11.3362 13.6679 11.4062 13.4058 11.5402 13.1754L13.8798 9.12161V9.11945ZM11.0098 11.3124C10.7646 11.5744 10.4221 11.7234 10.0632 11.7242H6.8223C6.10863 11.7246 5.52978 11.1463 5.5294 10.4326C5.5294 10.401 5.53053 10.3693 5.53285 10.3377L5.79591 6.63973C5.8785 5.3134 6.91201 4.24334 8.23467 4.11472C9.69425 4.00179 10.969 5.09346 11.082 6.55304C11.0824 6.55822 11.0828 6.56339 11.0831 6.56857L11.3527 10.3377C11.3781 10.6961 11.254 11.0489 11.0098 11.3124Z"
                    fill={color}
                />
                <path
                    d="M12.2855 13.6071C12.2291 13.7064 12.1994 13.8185 12.1992 13.9327L12.21 17.4797L14.4137 13.6653C14.5241 13.4542 14.7847 13.3727 14.9958 13.483C15.2068 13.5934 15.2884 13.854 15.178 14.0651C15.1724 14.0758 15.1663 14.0863 15.1598 14.0965L12.9561 17.9132L16.0353 16.1472C16.1346 16.0906 16.2172 16.0088 16.2746 15.91L18.4805 12.089C18.4676 12.0826 14.5043 9.79476 14.4936 9.78613L12.2855 13.6071Z"
                    fill={color}
                />
                <path
                    d="M19.6464 9.98894L15.7284 7.72916C15.384 7.50976 14.927 7.6111 14.7076 7.95551C14.6946 7.97578 14.6827 7.9967 14.6718 8.0181C14.4639 8.38564 14.5921 8.85204 14.9586 9.06174L18.8766 11.3237C19.2092 11.5424 19.6562 11.4501 19.8749 11.1174C19.8751 11.1171 19.8754 11.1168 19.8756 11.1165C20.1475 10.7109 20.0996 10.2488 19.6464 9.98894Z"
                    fill={color}
                />
                <path
                    d="M23.6198 1.59193L21.0128 0.0868462C20.7034 -0.0918556 20.3078 0.0140717 20.1291 0.32339C20.129 0.323606 20.1289 0.323821 20.1287 0.324037L16.2539 7.03438L19.9821 9.18851L23.857 2.47601C24.0357 2.16663 23.9297 1.77101 23.6204 1.59231C23.6202 1.5922 23.62 1.59204 23.6198 1.59193Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_10693_2659">
                    <rect width="24" height="24" fill="white" transform="translate(0.554688)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconTextStyle;
